import { useEffect, useState, useRef } from "react";
import "../../../design/header.css"; // your CSS

export default function TypewriterTerminal() {
    const [text, setText] = useState("");
    const fullText = "C:\\Users\\REKTOVSKI>\ncd Portfolio.port";
    const indexRef = useRef(0);

    useEffect(() => {
        const type = () => {
            if (indexRef.current < fullText.length) {
                const char = fullText[indexRef.current];
                setText((prev) => prev + char);

                indexRef.current++;
                const randomSpeed = Math.random() * 200 + 50; // typing speed
                setTimeout(type, randomSpeed);
            }
        };

        type(); // start typing immediately
    }, []);

    return (
        <div className="headerTerminal">
            {text}
            <span className="cursor">_</span>
        </div>
    );
}